import { gql } from '@apollo/client';
import { INSTITUTION } from '../../fragments';

export const FILTERED_INSTITUTIONS = gql`
  query FilteredInstitutions($input: FilterInstitutions!) {
    institutions: filteredInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...institution
        }
      }
    }
  }
  ${INSTITUTION}
`;

export const FILTERED_INSTITUTIONS_SELECT = gql`
  query FilteredInstitutionsSelect($input: FilterInstitutions!) {
    institutions: filteredInstitutionsNoCache(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          emisNumber
          district {
            id
            name
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`;
